import i18next from "i18next";

import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';


let acceptLanguage:any;
const metaTags = document.getElementsByTagName('meta');

for (let i = 0; i < metaTags.length; i++) {
    if (metaTags[i].getAttribute('http-equiv') === 'Accept-Language') {
      acceptLanguage = metaTags[i].getAttribute('content');
      break;
    }
    //acceptLanguage = 'pt';
}

const languageDetector:any = {
  type: 'languageDetector',
  async: true,
    detect: (cb:any) => cb(acceptLanguage),
  init: () => {},
  cacheUserLanguage: () => {}
};

i18next
    .use(Backend)
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        resources: {
            en: {
                translation: translationEN
            },
            pt: {
                translation: translationPT
            },
        },
        fallbackLng: {
            default: ['en'],
            'pt-BR': ['pt'],
            'pt-PT': ['pt'],
            'pt_BR': ['pt'],
        },
        interpolation: {
            escapeValue: false
        }
    });

export default i18next;
